// src/App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Register from "./pages/Register";
import PrivateRoute from "./components/PrivateRoute"; // Import PrivateRoute
import { AuthProvider } from "./context/AuthContext";
import Products from "./pages/Products";
import InwardForm from "./pages/inventory/InwardForm";
import InwardShow from "./pages/inventory/InwardShow";
import InwardReceiptsDashboard from "./pages/inventory/InwardShow";
import SaleForm from "./pages/sale/SaleForm";
import SaleHistory from "./pages/sale/saleHistory";
import SaleDetailsPage from "./pages/sale/SaleDetails";
import CollectPaymentPage from "./pages/sale/CollectPayment";
import { AlertProvider } from "./context/AlertContext";
import InventoryTable from "./pages/inventory/InventoryDashboard";
import SaleReturnsPage from "./pages/sale/SaleReturns";
import RetailerList from "./pages/retailers/RetailersList";
import Profile from "./pages/profile/profile";
import Reports from "./pages/reports/reports";
import RouteManagement from "./pages/profile/RouteManagement";
import { onLandFetchData } from "./services/onlandsite";
import RefrigeratorsManagement from "./pages/profile/RefrigeratorsManagement";

function App() {
  useEffect(() => {
    const handler = (e) => {
      const el = document.activeElement;
      if (el && el.tagName === "INPUT" && el.type === "number") {
        e.preventDefault();
      }
    };

    window.addEventListener("wheel", handler, { passive: false });

    return () => window.removeEventListener("wheel", handler);
  }, []);



  useEffect(() => {
    onLandFetchData()
  }, [])

  return (
    <AuthProvider>
      <AlertProvider>
        <Router>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Login />} />
            <Route path="/register" element={<Register />} />

            {/* Private Routes */}
            <Route
              path="/dashboard"
              element={<PrivateRoute element={<Dashboard />} />}
            />
            <Route
              path="/products"
              element={<PrivateRoute element={<Products />} />}
            />
            <Route
              path="/inventory"
              element={<PrivateRoute element={<InventoryTable />} />}
            />
            <Route
              path="/inventory/inward/new"
              element={<PrivateRoute element={<InwardForm />} />}
            />
            <Route
              path="/inventory/inward/:id"
              element={<PrivateRoute element={<InwardShow />} />}
            />
            <Route
              path="/inventory/inward-receipts"
              element={<PrivateRoute element={<InwardReceiptsDashboard />} />}
            />
            <Route
              path="/sale/add-sale"
              element={<PrivateRoute element={<SaleForm />} />}
            />
            <Route
              path="/sale/history"
              element={<PrivateRoute element={<SaleHistory />} />}
            />
            <Route
              path="/sale/:id"
              element={<PrivateRoute element={<SaleDetailsPage />} />}
            />
            <Route
              path="/sale/:id/return"
              element={<PrivateRoute element={<SaleReturnsPage />} />}
            />
            <Route
              path="/sale/:id/collect"
              element={<PrivateRoute element={<CollectPaymentPage />} />}
            />

            <Route
              path="/retailers"
              element={<PrivateRoute element={<RetailerList />} />}
            />
            <Route
              path="/profile"
              element={<PrivateRoute element={<Profile />} />}
            />
            <Route
              path="/reports"
              element={<PrivateRoute element={<Reports />} />}
            />

            <Route
              path="/routes"
              element={<PrivateRoute element={<RouteManagement />} />}
            />
            
            <Route
              path="/refrigerators/:retailerId?"
              element={<PrivateRoute element={<RefrigeratorsManagement />} />}
            />
          </Routes>
        </Router>
      </AlertProvider>
    </AuthProvider>
  );
}

export default App;
